module.exports = __webpack_public_path__ + "img/F253A8AA9B6D6B604ED66261D5072D8B.f253a8aa.png";